export const DialogFileDialogFiles = {
    textAlign: 'center',
    padding: '0',
};

export const DialogFileBoxDialog = {
    position: 'relative',
    left: '0',
    margin: 'auto',
    marginTop: '1.25rem',
};

export const DialogFileBoxStepDialog = {
    position: 'relative',
    left: '0',
    margin: 'auto',
    marginTop: '1.25rem',
    marginBottom: '1.25rem',
};

export const DialogFileBoxText = { display: 'flex', justifyContent: 'center' };

export const DialogFileBoxDialogAction = {
    display: 'flex',
    gap: '1.25rem',
    padding: '1.25rem 0',
    flexFlow: 'wrap',
};
